<div [ngClass]="router.url.replace('/', '')" id="advertisementBannerComponent">
  <div class="scrolling-text" [@scroll]="state" (@scroll.done)="scrollDone()" [innerHTML]="advBanner()"></div>
</div>
